import { render, staticRenderFns } from "./PermissionToolAction.vue?vue&type=template&id=58e209d6&scoped=true&"
import script from "./PermissionToolAction.vue?vue&type=script&lang=js&"
export * from "./PermissionToolAction.vue?vue&type=script&lang=js&"
import style0 from "./PermissionToolAction.vue?vue&type=style&index=0&id=58e209d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e209d6",
  null
  
)

export default component.exports